import { createSvgIcon } from "@mui/material";

export const FalIcon = createSvgIcon(
  <svg viewBox="0 0 40 40" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.4755 8.00073C23.8913 8.00073 24.2245 8.33878 24.2642 8.75261C24.6187 12.4439 27.5566 15.3815 31.2481 15.736C31.662 15.7757 32 16.1089 32 16.5246V23.4753C32 23.8909 31.662 24.2241 31.2481 24.264C27.5566 24.6185 24.6187 27.556 24.2642 31.2472C24.2245 31.6611 23.8913 31.9992 23.4755 31.9992H16.5245C16.1087 31.9992 15.7755 31.6611 15.7358 31.2472C15.3813 27.556 12.4434 24.6185 8.75192 24.264C8.33807 24.2241 8 23.8909 8 23.4753V16.5246C8 16.1089 8.33807 15.7757 8.75192 15.736C12.4434 15.3815 15.3813 12.4439 15.7358 8.75261C15.7755 8.33878 16.1087 8.00073 16.5245 8.00073H23.4755ZM12.8189 19.9796C12.8189 23.9726 16.0524 27.2094 20.0411 27.2094C24.0298 27.2094 27.2634 23.9726 27.2634 19.9796C27.2634 15.9867 24.0298 12.7498 20.0411 12.7498C16.0524 12.7498 12.8189 15.9867 12.8189 19.9796Z"
      fill="currentColor"
    />
  </svg>,
  "FalIcon",
);
